import { FileType } from '@office-start/document-types';
var idToFileTypeMap = new Map([
    ["ShellWordOnline" /* FirstPartyWorkloadIds.Word */, FileType.Word],
    ["ShellExcelOnline" /* FirstPartyWorkloadIds.Excel */, FileType.Excel],
    ["ShellPowerPointOnline" /* FirstPartyWorkloadIds.PowerPoint */, FileType.PowerPoint],
    ["ShellOneNoteOnline" /* FirstPartyWorkloadIds.OneNote */, FileType.OneNote],
    ["ShellClassNotebook" /* FirstPartyWorkloadIds.ClassNotebook */, FileType.OneNoteClassNoteBook],
    ["ShellVisioOnline" /* FirstPartyWorkloadIds.Visio */, FileType.Visio],
    ["ShellSway" /* FirstPartyWorkloadIds.Sway */, FileType.Sway],
    ["ShellOfficeForms" /* FirstPartyWorkloadIds.Forms */, FileType.Forms],
    ["ShellDocuments" /* FirstPartyWorkloadIds.OneDrive */, FileType.OneDrive],
    ["ShellSites" /* FirstPartyWorkloadIds.SharePoint */, FileType.SharePoint],
    ["ShellMicrosoftStream" /* FirstPartyWorkloadIds.Stream */, FileType.Stream],
    ["ShellLists" /* FirstPartyWorkloadIds.Lists */, FileType.List],
    ["ShellWhiteboard" /* FirstPartyWorkloadIds.Whiteboard */, FileType.Whiteboard],
    ["ShellProject" /* FirstPartyWorkloadIds.Project */, FileType.Project],
    ["ShellClipchamp" /* FirstPartyWorkloadIds.Clipchamp */, FileType.Clipchamp],
]);
export function getFileTypeFromWorkloadId(workloadId) {
    return idToFileTypeMap.get(workloadId);
}
//# sourceMappingURL=getFileTypeFromWorkloadId.js.map